// Validated, internal-only return destinations after sign-in (email/password and Google).
const KEY = "fl_auth_return";
const TTL_MS = 30 * 60 * 1000;

export const safeReturn = (next) => {
  if (typeof next !== "string") return null;
  const ok = next === "/education" || next === "/my-classes"
    || /^\/join(\/[A-Za-z0-9_-]{6,64}|\?code=[A-Z0-9]{6})?$/.test(next)
    || /^\/(my-classes|assignment)\/[A-Za-z0-9_-]{1,64}$/.test(next);
  return ok ? next : null;
};

// Same tab/device only (sessionStorage), short-lived, single-use.
export const rememberReturn = (next) => {
  const path = safeReturn(next);
  if (path) sessionStorage.setItem(KEY, JSON.stringify({ path, exp: Date.now() + TTL_MS }));
  else sessionStorage.removeItem(KEY);
};

export const clearReturn = () => sessionStorage.removeItem(KEY);

export const takeReturn = () => {
  const raw = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  try {
    const { path, exp } = JSON.parse(raw || "null") || {};
    return exp > Date.now() ? safeReturn(path) : null;
  } catch { return null; }
};
